import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f4eb49a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col overflow-y-auto w-full h-full pt-4 space-y-4 bg-white rounded-lg webchat-shadow" }
const _hoisted_2 = { class: "flex flex-col z-10 ml-4 text-white relative" }
const _hoisted_3 = { class: "text-2xl mb-1" }
const _hoisted_4 = {
  key: 0,
  class: "w-60 text-white text-sm opacity-80"
}
const _hoisted_5 = { class: "z-10 text-sm" }
const _hoisted_6 = { class: "bg-white rounded-t-none rounded-b flex flex-col space-y-2" }
const _hoisted_7 = { class: "px-6 py-6 flex flex-col items-start gap-3" }
const _hoisted_8 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row gap-3"
}
const _hoisted_10 = { class: "flex flex-row -space-x-10" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "flex flex-col justify-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Nosso tempo de reposta", -1))
const _hoisted_14 = { class: "flex flex-row items-center gap-1 font-semibold" }
const _hoisted_15 = { class: "flex flex-col space-y-4 pb-3 w-full" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Carregando...", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enviar uma mensagem", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseButton = _resolveComponent("CloseButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "w-full h-64 rounded-t-lg absolute w-full z-0",
      style: _normalizeStyle(`background-color: ${_ctx.store.data?.bgColor}`)
    }, null, 4),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(_component_CloseButton, {
          onCloseBox: _cache[0] || (_cache[0] = () => _ctx.emit('close-box')),
          class: "right-2 -top-3"
        }),
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.store.data.title), 1),
        (_ctx.store.data.description.length > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.store.data.description), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Insira seus dados para iniciarmos! "))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.data.attendants, (attendant, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: index,
                        src: attendant.photo,
                        class: "w-16 h-16 rounded-full border-2 border-white",
                        alt: "Foto do atendente"
                      }, null, 8, _hoisted_11))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Icon, {
                        name: "Time",
                        size: "16",
                        color: "text-blue-700"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.store.data.timeAttendance), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_FormInput, {
                modelValue: _ctx.state.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.name) = $event)),
                type: "text",
                label: "Nome",
                placeholder: "Digite seu nome",
                "is-loading": _ctx.state.isLoading,
                "message-error": _ctx.validation.name,
                onValidate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateState('name')))
              }, null, 8, ["modelValue", "is-loading", "message-error"]),
              _createVNode(_component_FormInput, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.email) = $event)),
                type: "email",
                label: "Email",
                placeholder: "Seu melhor e-mail",
                "is-loading": _ctx.state.isLoading,
                "message-error": _ctx.validation.email,
                onValidate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateState('email')))
              }, null, 8, ["modelValue", "is-loading", "message-error"])
            ]),
            _createElementVNode("button", {
              type: "button",
              disabled: !_ctx.submitButtonIsDisable,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
              class: _normalizeClass(["webchat-transition rounded-full text-white flex flex-row gap-2 py-3 px-5 w-full justify-center", {'opacity-50 cursor-not-allowed': !_ctx.submitButtonIsDisable}]),
              style: _normalizeStyle(`background-color: ${_ctx.store.data?.bgColor}`)
            }, [
              (_ctx.state.isLoading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Icon, {
                      name: "loading",
                      size: "19"
                    }),
                    _hoisted_17
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_Icon, {
                      name: "Send",
                      size: "19"
                    }),
                    _hoisted_18
                  ], 64))
            ], 14, _hoisted_16)
          ])
        ])
      ])
    ])
  ], 64))
}